module.exports = __webpack_public_path__ + "files/e7ce1b3e155009268c94d707f86491c0.png";